/**
 * Unified JSON schema form
 */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { IFormGroupPreferences } from '../services/schema-form';
import { COLLAPSE_ANIMATION_DURATION_MS } from '@config/index';
import { IFormAction } from '../services';
import { first, get, has } from 'lodash';
import { Subject, Subscription } from '@shared/rx';
import { hasMethod } from '@shared/utils';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-schema-form',
  templateUrl: 'schema-unified.form.component.html',
  styleUrls: ['schema-unified.form.component.scss'],
})
export class XVISchemaFormComponent implements OnChanges {
  @Input() public form: FormGroup;
  @Input() public groups: IFormGroupPreferences[];
  @Input() public disabled: boolean = false;
  @Output() public onFormAction: EventEmitter<IFormAction> = new EventEmitter();

  public currentPage: number = 0;
  public currentOpenPage: number = 0;
  public subscriptions: Subscription[] = [];

  private formAction: Subject<IFormAction>;

  public ngOnChanges(changes): void {
    if (has(changes, 'groups') && !this.formAction) {
      this.initFormAction();
    }
  }

  public visibleFields(allFields): any {
    return allFields.filter((field) => field.visible);
  }

  public handlePageHeaderClick(pageIndex): void {
    this.currentOpenPage = pageIndex === this.currentOpenPage ? -1 : pageIndex;
    // should set 'in' class when collapsing animation already in progress
    setTimeout(
      () => (this.currentPage = pageIndex),
      COLLAPSE_ANIMATION_DURATION_MS,
    );
  }

  public getUniqueGroupId(group, groupIndex): string {
    const groupId = group.id ? `_${group.id}_` : '';

    return `${groupId}${groupIndex}`;
  }

  private initFormAction(): void {
    this.formAction = get(first(this.groups), 'action');
    if (!hasMethod(this.formAction, 'subscribe')) return;

    this.subscriptions.push(
      this.formAction.subscribe((action) => {
        this.onFormAction.emit({
          ...action,
          formValue: this.form.value,
        });
      }),
    );
  }
}
